import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const Modal = ({ show, children, onClose, zIndex = 9999 }) => {
  useEffect(() => {
    if (show) {
      // Zabránit scrollování při otevřeném modalu
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [show]);

  if (!show) return null;

  const modalContent = (
    <div 
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        zIndex,
        padding: '20px',
        overflow: 'auto',
        margin: 0
      }}
      onClick={(e) => {
        // Zavřít při kliknutí na pozadí
        if (e.target === e.currentTarget && onClose) {
          onClose();
        }
      }}
    >
      {children}
    </div>
  );

  // Použít Portal - renderovat mimo Layout hierarchii
  return createPortal(modalContent, document.body);
};

export default Modal;
